import { isInteger } from 'formik';

import { IPageActions } from '@chess-class/sandbox';

enum VideosPageActionEnum {
  'create',
  'edit',
  'view',
}

export type IVideosPageActions = {
  action: keyof typeof VideosPageActionEnum;
  actionId: string;
  actionStep: number | string;
};

export const videosPageActions: IPageActions<IVideosPageActions> = {
  action: {
    allowed: (value) => Object.keys(VideosPageActionEnum).includes(value),
    default: '',
  },
  actionId: {},
  actionStep: {
    allowed: (value) => isInteger(value),
    default: 0,
  },
};
